import React, { useState , useEffect} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const EditTaskPopup = ({modal, toggle, updateTask, taskObj}) => {
    const [taskId, setTaskid] = useState(''); //id
    const [sabun, setSabun] = useState(''); //id
    const [taskName, setTaskName] = useState(''); //할일제목
    const [description, setDescription] = useState(''); //할일내용
    const [taskDate, setTaskDate] = useState(''); //등록일자

    const handleChange = (e) => {       
        const {name, value} = e.target
        if (e.target.scrollHeight === e.target.clientHeight) {
            if(name === "taskName"){
                setTaskName(value)
            }else{
                setDescription(value)
            }
        }
    }

    useEffect(() => {
        setTaskid(taskObj.Id)
        setSabun(taskObj.t_개인사번)
        setTaskName(taskObj.t_할일제목)
        setDescription(taskObj.t_할일내용)
        setTaskDate(taskObj.t_등록일자)
    },[taskObj])

    const handleUpdate = (e) => {
        e.preventDefault();
        console.log(taskId)
        let taskObj = {}
        taskObj["id"] = taskId
        taskObj["t_개인사번"] = sabun
        taskObj["t_할일제목"] = taskName
        taskObj["t_할일내용"] = description
        taskObj["t_등록일자"] = taskDate
        updateTask(taskObj)
    }

    const handleUpdateMouse = (e) => {
        setTaskid(taskObj.id)
        setSabun(taskObj.t_개인사번)
        setTaskDate(taskObj.t_등록일자)
    }

    return (
        <Modal size='sm' isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>할일수정</ModalHeader>
            <ModalBody>
            
                    <div className = "form-group">
                        <div style={{margin: "0px",fontSize:"10px", textAlign:'right'}}>{taskObj.t_등록일자} Id:{taskObj.id} </div>
                        <label style={{color:'blue', fontWeight:'bolder'}}>제목</label>
                        <input type="text" className = "form-control" value = {taskName} onChange = {handleChange}  name = "taskName"/>
                    </div>
                    <div className = "form-group">
                        <label style={{color:'blue', fontWeight:'bolder'}}>내용</label>
                        <textarea wrap='hard' cols={30} rows={5} className = "form-control" value = {description} onChange = {handleChange} name = "description"></textarea>
                    </div>
                
            </ModalBody>
            <ModalFooter>
            <Button color="primary" 
                onClick={handleUpdate}
                onMouseMove={handleUpdateMouse}
            >
            수정
            </Button>{' '}
            <Button color="secondary" onClick={toggle}>취소</Button>
            </ModalFooter>
      </Modal>
    );
};

export default EditTaskPopup;